/* ==========================================================================
   Ryse - Theoric: card do item na gaveta do carrinho

     A. as TAGS: so IDENTIDADE do produto (tipo + medida). Dinheiro nao entra.
     B. o seletor de quantidade  -  [n]  +  e o "Remover"
     C. a COLUNA DO PRECO: riscado -> valor cobrado -> selo do desconto
     D. os avisos do servidor, que o tema mostrava e matava no mesmo instante

   -------------------------------------------------------------------------
   >>> ESTE ARQUIVO NAO BUSCA O CARRINHO E NAO REDESENHA A GAVETA. <<<
   Ele se inscreve em TheoricCart (theoric-cart-core.js), pinta o que ja existe,
   e manda as acoes pelo nucleo (TheoricCart.mudarLinha).

   ==========================================================================
   C. A COLUNA DO PRECO - e por que o selo do cupom mudou de lugar

   O selo morava na linha das TAGS, junto do tipo e da medida. Dois problemas,
   os dois MEDIDOS:

   1. ELE NUNCA COUBE. A linha de tags tem 204px uteis; o conteudo pedia 226px.
      Quebrava linha em TODA largura - inclusive em 1280px, com a gaveta em
      1216px. Nao era falta de tela: era conta que nao fecha. Custava uma linha
      inteira de altura em todo card com cupom.

   2. ELE NAO E IDENTIDADE, E DINHEIRO. "OLEO" e "50 ML" dizem o que o produto
      E. "-R$ 19,90" diz o que ele CUSTA. Na mesma linha, o olho le o desconto
      como se fosse mais um atributo do produto - e o preco, que e onde a pessoa
      confere a conta, ficava do outro lado do card.

   Agora a coluna conta a historia inteira, de cima para baixo (ordem escolhida
   pelo Romulo):

       R$ 199,00        <- riscado: o que era
       R$ 179,10        <- o que vai ser cobrado
       BB10  -R$ 19,90  <- o que foi abatido, e por qual cupom

   >>> O CODIGO DO CUPOM: TIROU E VOLTOU <<<
   Tirei o codigo por coerencia com o rodape (la ele aparecia 3x na mesma gaveta
   e virava ruido). Romulo pediu de volta - e ele tem razao aqui: no CARD, o
   codigo responde uma pergunta que o rodape nao responde - "por que ESTE item
   ficou mais barato?". Com dois cupons, ou com um desconto automatico somado a
   um cupom, o valor sozinho nao diz de onde veio.
   No rodape ele continua fora: la o total ja e a soma de tudo, e o nome nao
   acrescenta nada.

   >>> ARMADILHA QUE ESSA COLUNA CARREGA - LEIA ANTES DE MEXER <<<
   Ela e `position: absolute`: esta FORA DO FLUXO. NADA que voce puser dentro
   dela empurra o card. Se ela crescer, ela COBRE - e o "Remover" mora bem
   debaixo dela (ja ficou INCLICAVEL uma vez, sob uma placa invisivel de 63px).
   Quem garante o espaco agora e a FOTO (ver theoric-cart-preco.css).
   Se voce adicionar mais uma linha aqui, MECA a folga do botao - com
   elementFromPoint, nao com `.click()`, que ignora o hit-test.
   ==========================================================================

   COMO O TEMA TRATA QUANTIDADE (mapeado em 11/07/2026)
   O <select> do tema continua no DOM, escondido, como rede de seguranca - mas
   NAO manda mais: os botoes falam com TheoricCart.mudarLinha(), que muda a
   quantidade sem redesenhar nada. Antes eles disparavam 'change' no select, e o
   tema respondia com /cart/change COM `sections` -> renderContents -> DOIS
   ciclos de demolicao da gaveta por clique (medido: 14 sumicos).

   >>> O TETO DE QUANTIDADE: NENHUM DADO DO CLIENTE SABE QUAL E <<<
     select.options.length      -> 50 opcoes FIXAS, sem relacao com o produto
     variant.inventory_quantity -> dizia 461 num produto que o servidor recusa
                                   acima de 50
   Entao o servidor e a autoridade, e a interface APRENDE COM ELE: se um aumento
   e recusado (422), a quantidade que ficou E o teto. Ver tetosAprendidos.

   >>> ARMADILHA: item.key NAO SERVE COMO CHAVE DE CACHE (medido) <<<
   O hash do item.key MUDA conforme o endpoint (/cart.js vs /cart/update.js).
   Por isso metaServe compara VARIANTE_ID.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.TheoricCart;
  if (!T) {
    console.error('[theoric-cart-item] theoric-cart-core.js nao carregou.');
    return;
  }

  var meta = null;
  var buscandoMeta = null;
  var TEMPO_AVISO = 5000;
  var tetosAprendidos = {};

  var MENOS = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>';
  var MAIS  = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';

  function itens() { return document.querySelectorAll('cart-theoric .cart-item'); }

  function origemDaLinha(linha) {
    var props = (linha && linha.properties) || {};
    if (props._brinde === 'true') return 'brinde';
    if (props._source === 'Recomendação do Quiz') return 'quiz';
    return 'manual';
  }

  /* O Liquid agrupa os cards em "manual" e "quiz", mas /cart.js preserva a
     ordem real das linhas. Com o brinde, assumir que DOM[i] === cart.items[i]
     faria quantidade e preco acertarem o produto errado. A variante + origem
     recompõem o vinculo, e cada indice so pode ser usado uma vez. */
  function mapearLinhas(carrinho) {
    var linhas = (carrinho && carrinho.items) || [];
    var usados = {};

    return Array.prototype.map.call(itens(), function (card) {
      var variante = String(card.dataset.variantId || '');
      var origem = card.dataset.source || 'manual';
      var indice = -1;

      linhas.some(function (linha, i) {
        if (usados[i]) return false;
        if (String(linha.variant_id) !== variante) return false;
        if (origemDaLinha(linha) !== origem) return false;
        indice = i;
        return true;
      });

      if (indice < 0) {
        linhas.some(function (linha, i) {
          if (usados[i] || String(linha.variant_id) !== variante) return false;
          indice = i;
          return true;
        });
      }

      if (indice >= 0) {
        usados[indice] = true;
        card.dataset.cartLine = String(indice + 1);
      }

      return { card: card, indice: indice };
    });
  }

  /* ========================================================================== */
  function metaServe(carrinho) {
    if (!meta) return false;
    var linhas = (carrinho && carrinho.items) || [];
    if (meta.length !== linhas.length) return false;
    for (var i = 0; i < linhas.length; i++) {
      if (!meta[i]) return false;
      if (String(meta[i].variante_id) !== String(linhas[i].variant_id)) return false;
    }
    return true;
  }

  function garantirMeta(carrinho) {
    if (metaServe(carrinho)) return Promise.resolve(meta);
    if (buscandoMeta) return buscandoMeta;

    buscandoMeta = fetch('/?section_id=theoric-cart-meta')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-theoric-cart-meta]');
        if (!el) throw new Error('secao theoric-cart-meta nao encontrada');
        meta = JSON.parse(el.textContent);
        return meta;
      })
      .catch(function (e) {
        console.warn('[theoric-cart-item] nao foi possivel ler os metadados.', e);
        meta = null;
        return null;
      })
      .finally(function () { buscandoMeta = null; });

    return buscandoMeta;
  }

  function tetoDe(indice, carrinho) {
    var linha = carrinho.items[indice];
    var palpite = 0;
    if (meta && meta[indice]) {
      var t = Number(meta[indice].teto);
      if (t > 0) palpite = t;
    }
    var aprendido = tetosAprendidos[linha.variant_id] || 0;
    if (palpite && aprendido) return Math.min(palpite, aprendido);
    return aprendido || palpite || 0;
  }

  /* ==========================================================================
     A. AS TAGS - so IDENTIDADE (tipo + medida). Dinheiro nao entra.
     ========================================================================== */
  function textoDaMedida(indice) {
    var dados = meta ? meta[indice] : null;
    if (!dados) return '';
    return (dados.variante && dados.variante.trim()) ||
           (dados.conteudo && dados.conteudo.trim()) || '';
  }

  function montarTags(item, indice) {
    var wrapper = item.querySelector('.cart-item__name-wrapper');
    if (!wrapper) return;

    var texto = textoDaMedida(indice);
    var existente = wrapper.querySelector('.theoric-cart-item__tags');

    /* A assinatura agora e so a MEDIDA - o selo do cupom saiu daqui. Antes, o
       desconto entrava nesta assinatura, e era isso que obrigava a linha inteira
       a ser reconstruida a cada cupom aplicado. */
    if (existente) {
      if (existente.dataset.assinatura === texto) return;
      var medidaAntiga = existente.querySelector('.theoric-cart-item__meta');
      if (medidaAntiga) medidaAntiga.remove();
      if (texto) {
        var m = document.createElement('span');
        m.className = 'theoric-cart-item__meta';
        m.textContent = texto;
        existente.appendChild(m);
      }
      existente.dataset.assinatura = texto;
      return;
    }

    var selo = wrapper.querySelector('.product__type');
    if (!selo && !texto) return;

    var linha = document.createElement('div');
    linha.className = 'theoric-cart-item__tags';
    linha.dataset.assinatura = texto;

    if (selo) linha.appendChild(selo); // move o selo do tema para dentro

    if (texto) {
      var medida = document.createElement('span');
      medida.className = 'theoric-cart-item__meta';
      medida.textContent = texto;
      linha.appendChild(medida);
    }

    wrapper.appendChild(linha);
  }

  /* ==========================================================================
     C. A COLUNA DO PRECO:  riscado -> valor cobrado -> selo do desconto

     Le de cima para baixo como um recibo: era 199,00; vai pagar 179,10; foram
     abatidos 19,90 pelo cupom BB10.

     A classe `tem-desconto` no card e usada pelo CSS (alarga a coluna para o
     selo caber, e serve de rede de seguranca onde :has() nao existe).
     ========================================================================== */
  function textoDoSelo(linha) {
    var abatido = linha.total_discount || 0;
    var valor = '−' + T.moeda(abatido);

    var descontos = linha.discounts || [];

    /* Com UM desconto, o codigo responde "por que este item ficou mais barato?".
       Com VARIOS, nomear so um seria mentira por omissao - o valor e a soma de
       todos, e nenhum titulo sozinho explica o numero. Entao so o valor. */
    if (descontos.length === 1 && descontos[0].title) {
      return descontos[0].title + '  ' + valor;
    }

    return valor;
  }

  function precoCheioDoKit(item, indice, linha) {
    var dados = meta && meta[indice] ? meta[indice] : null;
    var eKit = item.classList.contains('cart-item--kit') || !!(dados && dados.kit);
    if (!eKit) return 0;

    var cadastrado = Number(dados && dados.kit_compare_at_line_price) || 0;
    if (cadastrado > linha.line_price) return cadastrado;

    /* Rede de seguranca: o Liquid normalmente entrega o compare-at real. Se a
       ponte de metadados falhar, recompomos apenas a referencia VISUAL dos 15%;
       o valor cobrado e o total do carrinho continuam intocados. */
    return Math.round(linha.line_price / 0.85);
  }

  function textoDoSeloKit(precoCheio, precoKit) {
    return 'KIT  −' + T.moeda(Math.max(0, precoCheio - precoKit));
  }

  function montarPreco(item, indice, carrinho) {
    if (!carrinho || !carrinho.items) return;

    var linha = carrinho.items[indice];
    if (!linha) return;

    var coluna = item.querySelector('.cart-item__quantity');
    var total = item.querySelector('.cart-item__totals');
    if (!coluna || !total) return;

    var props = linha.properties || {};
    if (props._brinde === 'true') {
      item.classList.add('cart-item--brinde');
      item.classList.remove('tem-desconto');

      var cheioBrinde = coluna.querySelector('.theoric-cart-item__preco-cheio');
      var seloBrinde = coluna.querySelector('.theoric-cart-item__cupom');
      if (cheioBrinde) cheioBrinde.remove();
      if (seloBrinde) seloBrinde.remove();

      rolar(total, 'Brinde');
      return;
    }

    var abatido = linha.total_discount || 0;   // soma TODOS os descontos da linha
    var temDescontoReal = abatido > 0 && linha.line_price < linha.original_line_price;
    var precoCheioKit = temDescontoReal ? 0 : precoCheioDoKit(item, indice, linha);
    var temDescontoKit = precoCheioKit > linha.line_price;
    var temDesconto = temDescontoReal || temDescontoKit;

    item.classList.toggle('tem-desconto', temDesconto);

    var cheio = coluna.querySelector('.theoric-cart-item__preco-cheio');
    var selo = coluna.querySelector('.theoric-cart-item__cupom');

    if (!temDesconto) {
      if (cheio) cheio.remove();
      if (selo) selo.remove();
      rolar(total, T.moeda(linha.line_price));
      return;
    }

    /* 1. o riscado */
    if (!cheio) {
      cheio = document.createElement('span');
      cheio.className = 'theoric-cart-item__preco-cheio is-novo';
      coluna.insertBefore(cheio, total);
    }
    var textoCheio = T.moeda(temDescontoKit ? precoCheioKit : linha.original_line_price);
    if (cheio.textContent !== textoCheio) cheio.textContent = textoCheio;

    /* 2. o valor cobrado (o proprio .cart-item__totals do tema) */
    rolar(total, T.moeda(linha.line_price));

    /* 3. o selo do abatido - a ORDEM VISUAL e garantida por `order` no CSS, nao
       pela ordem de insercao aqui. Uma nao pode depender da outra. */
    var texto = temDescontoKit
      ? textoDoSeloKit(precoCheioKit, linha.line_price)
      : textoDoSelo(linha);

    if (!selo) {
      selo = document.createElement('span');
      selo.className = 'theoric-cart-item__cupom is-novo';
      selo.textContent = texto;
      coluna.appendChild(selo);
      return;
    }

    if (selo.textContent !== texto) selo.textContent = texto;
  }

  /* Se o modulo de rolagem nao carregar, o valor ainda tem que aparecer:
     animacao ausente nao pode impedir o NUMERO de existir. */
  function rolar(el, texto) {
    if (!el) return;
    if (window.TheoricRolar) { window.TheoricRolar.trocar(el, texto); return; }
    if (el.textContent.trim() !== texto) el.textContent = texto;
  }

  /* ==========================================================================
     D. O AVISO
     O tema escreve num <div class="cart-item__error"> permanente do card, e o
     redesenho seguinte APAGA o texto - a mensagem some antes de ser lida.
     O nosso fica 5s e some sozinho.
     ========================================================================== */
  function avisar(item, mensagem) {
    var caixa = item.querySelector('.theoric-cart-item__aviso');

    if (!caixa) {
      caixa = document.createElement('p');
      caixa.className = 'theoric-cart-item__aviso';
      caixa.setAttribute('role', 'status');
      caixa.setAttribute('aria-live', 'polite');
      var acoes = item.querySelector('.cart-item__bottom-actions');
      if (acoes && acoes.parentNode) acoes.parentNode.insertBefore(caixa, acoes.nextSibling);
      else item.appendChild(caixa);
    }

    caixa.textContent = mensagem;
    caixa.classList.add('is-visivel');

    clearTimeout(caixa.__timer);
    caixa.__timer = setTimeout(function () {
      caixa.classList.remove('is-visivel');
    }, TEMPO_AVISO);
  }

  function textoDoTeto(n) {
    return n === 1
      ? 'Só é possível levar 1 unidade deste produto.'
      : 'Só é possível levar ' + n + ' unidades deste produto.';
  }

  /* ==========================================================================
     B. QUANTIDADE + REMOVER
     ========================================================================== */
  function posicaoDe(item) {
    // 1-based: e o `line` que o /cart/change.js espera. O atributo e atualizado
    // por mapearLinhas(), pois a ordem visual e agrupada por origem.
    var mapeada = Number(item.dataset.cartLine || 0);
    if (mapeada > 0) return mapeada;
    return Array.prototype.indexOf.call(itens(), item) + 1;
  }

  function ocupado(item, sim) {
    var q = item.querySelector('.theoric-qty');
    if (q) q.classList.toggle('is-busy', !!sim);
    item.classList.toggle('is-ocupado', !!sim);
  }

  function aplicarQuantidade(item, nova, anterior, varianteId) {
    var linha = posicaoDe(item);
    if (linha < 1) return;

    ocupado(item, true);

    T.mudarLinha(linha, nova)
      .then(function (res) {
        if (res.ok) return;

        /* O servidor recusou. Se era um AUMENTO, a quantidade que ficou no
           carrinho E o teto - deduzido, nao adivinhado. */
        if (nova > anterior && res.carrinho) {
          var atual = 0;
          (res.carrinho.items || []).forEach(function (i) {
            if (String(i.variant_id) === String(varianteId)) atual = i.quantity;
          });
          if (atual > 0) {
            tetosAprendidos[varianteId] = atual;
            avisar(item, textoDoTeto(atual));
            T.sincronizar(true);
            return;
          }
        }

        avisar(item, res.erro);
      })
      .catch(function (e) {
        console.error('[theoric-cart-item] falha ao mudar a quantidade.', e);
        avisar(item, 'Não foi possível alterar agora. Tente de novo.');
        T.sincronizar(true);
      })
      .finally(function () { ocupado(item, false); });
  }

  function remover(item) {
    var linha = posicaoDe(item);
    if (linha < 1) return;

    ocupado(item, true);

    T.mudarLinha(linha, 0)
      .then(function (res) {
        if (!res.ok) { avisar(item, res.erro); ocupado(item, false); return; }
        if (res.redesenhado) return;

        if (!res.carrinho.item_count) {
          T.redesenharGaveta();   // a unica demolicao legitima: o carrinho vazio
          return;
        }

        /* O card PRECISA sair do DOM antes da proxima pintura: a POSICAO de cada
           card e o endereco da linha no servidor. Isto nao e animacao - e
           correcao. */
        item.classList.add('is-saindo');
        setTimeout(function () {
          item.remove();
          T.sincronizar(true);
        }, 260);
      })
      .catch(function (e) {
        console.error('[theoric-cart-item] falha ao remover.', e);
        avisar(item, 'Não foi possível remover agora. Tente de novo.');
        ocupado(item, false);
      });
  }

  function montarQuantidade(item, indice, carrinho) {
    var caixa = item.querySelector('.cart-item__quantity-mobile');
    if (!caixa) return;

    var linha = carrinho.items ? carrinho.items[indice] : null;
    if (!linha) return;

    var select = caixa.querySelector('.theoric__qty-select');
    var atual = linha.quantity;
    var teto = tetoDe(indice, carrinho);

    /* o select do tema segue coerente - SEM disparar 'change', que acordaria o
       tema e traria a demolicao de volta */
    if (select && String(select.value) !== String(atual)) {
      select.value = String(atual);
    }

    var bloco = caixa.querySelector('.theoric-qty');

    if (!bloco) {
      bloco = document.createElement('div');
      bloco.className = 'theoric-qty';

      var menos = document.createElement('button');
      menos.type = 'button';
      menos.className = 'theoric-qty__btn';
      menos.innerHTML = MENOS;
      menos.setAttribute('aria-label', 'Diminuir quantidade');

      var valor = document.createElement('span');
      valor.className = 'theoric-qty__valor';
      valor.setAttribute('aria-live', 'polite');

      var mais = document.createElement('button');
      mais.type = 'button';
      mais.className = 'theoric-qty__btn';
      mais.innerHTML = MAIS;
      mais.setAttribute('aria-label', 'Aumentar quantidade');

      bloco.appendChild(menos);
      bloco.appendChild(valor);
      bloco.appendChild(mais);
      caixa.appendChild(bloco);

      menos.addEventListener('click', function () {
        var n = Number(bloco.dataset.qtd || 1);
        if (n <= 1) return; // no 1 o "-" nao zera: quem quer tirar usa "Remover"
        aplicarQuantidade(item, n - 1, n, bloco.dataset.variante);
      });

      mais.addEventListener('click', function () {
        var n = Number(bloco.dataset.qtd || 1);
        var t = Number(bloco.dataset.teto || 0);
        if (t && n >= t) { avisar(item, textoDoTeto(t)); return; }
        aplicarQuantidade(item, n + 1, n, bloco.dataset.variante);
      });
    }

    /* o estado vive no dataset - e dali que os botoes leem. Nunca de uma
       variavel de fechamento capturada na montagem: ela envelheceria. */
    bloco.dataset.qtd = String(atual);
    bloco.dataset.teto = String(teto);
    bloco.dataset.variante = String(linha.variant_id);

    var v = bloco.querySelector('.theoric-qty__valor');
    if (v && v.textContent !== String(atual)) v.textContent = String(atual);

    var btns = bloco.querySelectorAll('.theoric-qty__btn');
    btns[0].disabled = atual <= 1;
    btns[1].disabled = teto > 0 && atual >= teto;
  }

  /* O "Remover" do tema tambem chamava renderContents. Interceptamos na fase de
     CAPTURA: o listener do ancestral roda ANTES do listener do proprio botao, e
     stopImmediatePropagation impede que o do tema chegue a rodar. */
  function ligarRemover(item) {
    if (item.dataset.theoricRemover === '1') return;

    var botao = item.querySelector('cart-remove-button');
    if (!botao) return;

    botao.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      remover(item);
    }, true);

    item.dataset.theoricRemover = '1';
  }

  /* ==========================================================================
     PINTAR - chamado pelo nucleo a cada mudanca do carrinho
     ========================================================================== */
  function pintar(carrinho) {
    if (!carrinho || !carrinho.items) return;
    if (!itens().length) return;

    garantirMeta(carrinho).then(function () {
      mapearLinhas(carrinho).forEach(function (mapeado) {
        var item = mapeado.card;
        var i = mapeado.indice;
        if (i < 0 || !carrinho.items[i]) return;

        if (origemDaLinha(carrinho.items[i]) !== 'brinde') {
          montarQuantidade(item, i, carrinho);
          ligarRemover(item);
        }
        montarTags(item, i);
        montarPreco(item, i, carrinho);
      });
    });
  }

  T.ao(pintar);
})();
